import React from "react";
import './TestDataForm.css'
import moment from 'moment';
import {
    Form,
    Input,
    Tooltip,
    Icon,
    Select,
    Row,
    Col,
    Checkbox,
    Button,
    message,
    Popover,
    InputNumber
} from 'antd';
import CalculateVolumeToolTip from "./CalculateVolumeToolTip";
import { withApollo } from "react-apollo";
import { FIND_BY_ID_QUERY, CREATE_TEST_QUERY, UPDATE_TEST_QUERY } from "../../constants/graphql-query";
import QRCodeWithButton from "../qrCode/QRCodeWithButton";
import HOME from "../../constants/home-constant";

const { Option } = Select;
const testNameMaxChar = 10, createdByMaxChar = 30, descMaxChar = 30;


class TestDataForm extends React.Component {
    state = {
        confirmDirty: false,
        autoCompleteResult: [],
        testNameCharR: testNameMaxChar,
        createdByCharR: createdByMaxChar,
        descCharR: descMaxChar,
        addTempValue: false,
        mediavolumeCal: {
            foodWeight: 0,
            dilutionFactor: 0,
            calculatedVal: 0
        },
        formData: {}
    };

    componentDidMount() {
        this.disableNumberScroll();  
        this.disableNumberScroll();  
        // this.props.form.setFieldsValue({
        //     concentration: 1
        // });    
    }

    disableNumberScroll = () => {
        document.querySelectorAll('.ant-input-number-input').forEach((e) => {
            e.addEventListener('mousewheel', (e) => e.preventDefault())
        })
    }

    handleSubmit = e => {
        e.preventDefault();
        
        this.props.form.validateFieldsAndScroll((err, values) => {
            //console.log('values', values);
            if (!err) {
                const postData = {
                    instrumentVersion: "v1",
                    testName: values.testname,
                    modelDate: moment().format('YYYY-MM-DD'),
                    // modelDate: values.datepicker.format('YYYY-MM-DD'),
                    //createdBy: UserProfile.getLogonId(),
                    //createdFor: values.createdby,
                    description: values.desc,
                    mediaVolume: parseInt(values.mediavolume),
                    mediaFinalConcentration: parseFloat(values.concentration),
                    dispensingFlowRate: parseFloat(values.dispinseflow),
                    temperature: parseInt(values.temperature),
                    priorityMode: values.priority,
                    foodWeight: null,
                    dilutionFactor: null
                }
                //console.log('postData', postData);
                if (values.addtemp === false) {
                    postData.temperature = null;
                    postData.priorityMode = null;
                }

                if (!this.props.home.saveBtn) {
                    this.props.dispatch({ type: HOME.SET_PROP, value: [this.props.form.getFieldsValue()], prop: 'currentData' });
                    this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'qrCode' });
                    this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'showID' });
                } else {
                    if (values.id || (this.props.home.currentData && this.props.home.currentData[0].id)) {
                        postData.id = values.id || this.props.home.currentData[0].id;
                        postData.status = true;
                        // message.loading(this.props.t('form.updatemsg'), 0);
                        const client = this.props.client;
                        client.mutate({
                            mutation: UPDATE_TEST_QUERY,
                            variables: {
                                id: postData.id,
                                status: postData.status,
                                instrumentVersion: postData.instrumentVersion,
                                testName: postData.testName,
                                modelDate: postData.modelDate,
                               // createdBy: postData.createdBy,
                               // createdFor: postData.createdFor,
                                description: postData.description,
                                mediaVolume: postData.mediaVolume,
                                mediaFinalConcentration: postData.mediaFinalConcentration,
                                dispensingFlowRate: postData.dispensingFlowRate,
                                temperature: postData.temperature,
                                priorityMode: postData.priorityMode
                            }
                        }).then((data) => {
                            message.destroy();
                            this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'saveBtn' });
                            if (data.data.updateTestData) {
                                // message.success(this.props.t("form.updatedmsg"));
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'qrCode' });
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'refresTable' });
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'showID' });
                                this.props.dispatch({ type: HOME.SET_PROP, value: [{...this.props.form.getFieldsValue(), id: this.props.home.currentData[0].id}], prop: 'currentData' });
                            }
                            // message.error(this.props.t('form.errorsavingmsg'));
                        });
                    } else {
                        // message.loading(this.props.t('form.savingmsg'), 0);
                        const client = this.props.client;
                        client.mutate({
                            mutation: CREATE_TEST_QUERY,
                            variables: {
                                instrumentVersion: postData.instrumentVersion,
                                testName: postData.testName,
                                modelDate: postData.modelDate,
                                // createdBy: postData.createdBy,
                                // createdFor: postData.createdFor,
                                description: postData.description,
                                mediaVolume: postData.mediaVolume,
                                mediaFinalConcentration: postData.mediaFinalConcentration,
                                dispensingFlowRate: postData.dispensingFlowRate,
                                temperature: postData.temperature,
                                priorityMode: postData.priorityMode
                            }
                        }).then((data) => {
                            message.destroy();
                            this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'saveBtn' });
                            if (data.data.createTestData) {
                                message.success(this.props.t('form.savedmsg'));
                                this.props.dispatch({
                                    type: HOME.SET_PROP,
                                    value: [{...this.props.form.getFieldsValue(), id: data.data.createTestData.id}],
                                    prop: 'currentData'
                                });
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'showID' });
                                // this.props.form.setFieldsValue({
                                //     id: data.data.createTestData.id
                                // })
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'qrCode' });
                                this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'refresTable' });

                                //this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'isSaveClick' });
                                this.props.dispatch({ type: HOME.SET_PROP, value: [{...this.props.form.getFieldsValue(), id: this.props.home.currentData[0].id}], prop: 'currentData' });
                                //this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'modalShow' });
                            }
                            else
                                message.error(this.props.t('form.errorsavingmsg'));
                        });
                    }
                }

            } else {
                this.props.callback(null)
            }
        });

        return false;
    };
    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };
    handleInputChangeTest(e) {
        this.setState({
            testNameCharR: (testNameMaxChar - e.target.value.length)
        })
    }
    handleInputChangeCreated(e, stateName, stateValue) {
        this.setState({
            createdByCharR: (createdByMaxChar - e.target.value.length)
        })
    }
    handleInputChangeDesc(e, stateName, stateValue) {
        this.setState({
            descCharR: (descMaxChar - e.target.value.length)
        })
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.home.isEdit) {
            this.updateFormForEdit(nextProps.home.currentData)
        }
        
        if (nextProps.clearForm && this.state.addTempValue && !nextProps.form.isFieldTouched('temperature') && !nextProps.form.isFieldTouched('priority')) {
            this.setState({
                addTempValue: !nextProps.clearForm
            })
        }

    }
    componentDidUpdate(nextProps) {
        if (this.props.data && this.props.data !== nextProps.data) {
            this.props.form.resetFields();
            this.updateFormForEdit(nextProps.data);
        }
    }
    hidePopover = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = visible => {
        this.setState(
            { visible },
            () => {
                setTimeout(() => {
                    this.disableNumberScroll()
                }, 100)
            }
        );
    };

    calculateMediaVolume = () => {
        this.props.form.validateFields(['dilutionFactor', 'foodWeight'], (errors, values) => {
            if (!errors || (!(errors || {}).dilutionFactor || !(errors || {}).foodWeight) && this.props.form.getFieldValue('dilutionFactor') > 0) {
                this.props.form.setFieldsValue({
                    calculatedVal: ((this.props.form.getFieldValue('dilutionFactor') - 1) * this.props.form.getFieldValue('foodWeight'))
                });
                this.props.form.validateFields(['calculatedVal']);
            }
        });
    }

    updateMediaVolumeVal = (value) => {
        if (this.props.form.getFieldValue('calculatedVal')) {
            this.props.form.setFieldsValue({
                mediavolume: this.props.form.getFieldValue('calculatedVal')
            })

            this.props.form.validateFields(['mediavolume'], (errors, values) => {
                if (!errors || !(errors || {}).mediavolume) {
                    this.hidePopover();
                }
            });
        }

    }
    onAddTempChange(e) {
        this.setState({
            addTempValue: e.target.checked,
            testNameCharR: testNameMaxChar,
            descCharR: descMaxChar,
        },
        () => this.disableNumberScroll()
        )
        
    }
    updateFormForEdit = (formData) => {
        const data = formData || this.props.data;
        const client = this.props.client;
        const callback = this.updateFormData;
        client.query({
            query: FIND_BY_ID_QUERY,
            variables: { id: data[0].id }
        }).then((data) => {
            message.destroy();
            if (data.data.findById)
                callback(data.data.findById);
            else
                message.error(this.props.t('form.errorgettingdata'))
        });

    }

    updateFormData = (data) => {
        if (data) {
            const isTempAdded = data.temperature ? true : false;

            this.props.form.setFieldsValue({
                addtemp: isTempAdded
            })
            this.setState({
                addTempValue: isTempAdded,
                confirmDirty: true
            }, () => {
                this.props.form.setFieldsValue({
                    testname: data.testName,
                    //datepicker: moment(data.modelDate, dateFormat),
                    //createdby: data.createdFor,
                    desc: data.description,
                    dispinseflow: data.dispensingFlowRate,
                    concentration: data.mediaFinalConcentration,
                    id: data.id,
                    mediavolume: data.mediaVolume,
                    priority: data.priorityMode,
                    temperature: data.temperature
                });
                window.scrollTo(0, 0);
            })

        } else {
            message.error(this.props.t('form.errordataload'))
        }

        this.props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'isEdit' });
        this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'qrCode' });
        this.props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'showID' });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;
        const getTradeMark = () => <span className="sup"><font size="2">®</font></span>

        // const config = {
        //     initialValue: moment(),
        //     rules: [{ required: false, message: t('form.selectdatetext') }],
        // };

        return (
            <Form onSubmit={this.handleSubmit} layout="vertical" className="data-matrix-form" noValidate>
                <Row className="main-form-content" gutter={[24]}>
                    <Col span={15}>
                        <Row>
                            <Col span={24}>{t('main.infotextLine1')}{getTradeMark()} {t('main.infotextLine11')}</Col>
                            <Col span={24}>The <strong>{t('main.volumeCalculator')}</strong>{t('main.infotextLine2')}
                            </Col>
                            <Col span={24}>
                            {t('main.infotextLine3')}
                            <strong>{t('main.generate')}</strong>{t('main.infotextLine31')}<strong>&nbsp;printed&nbsp;</strong>or<strong>&nbsp;exported.&nbsp;​</strong><br/>
                            </Col>
                            <Col span={24} className="sub-title">{t('main.infotextLine32')} <strong>{t('main.clear')}</strong>button​.</Col>
                            <Col span={24} className="description">

                                <Form.Item className="hidden-id" style={{ display: "none" }}>
                                    {getFieldDecorator('id')(<Input />)}
                                </Form.Item>
                                {/* <Form.Item label={t('form.selectinstrversion')} className="product">
                                    {getFieldDecorator('selectinstrversion', {
                                        rules: [],
                                        initialValue: "1"
                                    })(<Select size="small">
                                        <Option value="1">ReadyStream®<span className="sup">TM</span>V1</Option>
                                    </Select>
                                    )}
                                </Form.Item> */}

                                <Row>
                                    <Col span={14}>
                                        <Form.Item label={t('form.testname')} className="test-name">
                                            {getFieldDecorator('testname', {
                                                rules: [
                                                    {
                                                        type: "string",
                                                        pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                                                        message: 'Please enter valid Input',
                                                    },
                                                    {
                                                        required: true,
                                                        message: t('form.inputerrormsg', { field: "Test Name" })
                                                    },
                                                    {
                                                        max: testNameMaxChar,
                                                        message: `Max size exceeded, ${testNameMaxChar} characters max`,
                                                    }
                                                ],
                                            })(<Input autoComplete="off" autoFocus maxLength={10} onChange={(e) => this.handleInputChangeTest(e)} size="small" />)}
                                            <span className="help-text">{`Characters remaining: ${this.state.testNameCharR} / ${testNameMaxChar}`}</span>
                                        </Form.Item>
                                    </Col>
                                    <Col span={10} align="right">
                                        {/* <Form.Item label={t('form.date')} className="date">
                                            {getFieldDecorator('datepicker', config)(<DatePicker disabled format={dateFormat} size="small" />)}
                                        </Form.Item> */}

                                    </Col>
                                </Row>
                                {/* <Form.Item label={t('form.createdby')}>
                                    {getFieldDecorator('createdby', {
                                        rules: [
                                            {
                                                type: "string",
                                                pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                                                message: 'Please enter valid Input',
                                            },
                                            {
                                                required: true,
                                                message: t('form.inputerrormsg', { field: "Created By" }),
                                            },
                                            {
                                                max: createdByMaxChar,
                                                message: `Max size exceeded, ${createdByMaxChar} characters max`,
                                            }
                                        ],
                                    })(<Input autoComplete="off" maxLength={30} onChange={(e) => this.handleInputChangeCreated(e)} size="small" />)}
                                    <span className="help-text">{`Characters remaining: ${this.state.createdByCharR} / ${createdByMaxChar}`}</span>
                                </Form.Item> */}

                                <Form.Item label={t('form.description')}>
                                    {getFieldDecorator('desc', {
                                        rules: [
                                            {
                                                type: "string",
                                                pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                                                message: 'Please enter valid Input',
                                            },
                                            {
                                                required: true,
                                                message: t('form.inputerrormsg', { field: "Description" }),
                                            },
                                            {
                                                max: descMaxChar,
                                                message: `Max size exceeded, ${descMaxChar} characters max`,
                                            }
                                        ],
                                    })(<Input autoComplete="off" maxLength={30} onChange={(e) => this.handleInputChangeDesc(e)} size="small" />)}
                                    <span className="help-text">{`Characters remaining: ${this.state.descCharR} / ${descMaxChar}`}</span>
                                </Form.Item>
                                <Row>
                                    <Col span={7} className="mr-30">
                                        <Form.Item label={<span> {t('form.mediavolume')} <Tooltip title={t('form.calcVolumeMinAndMax')}> <Icon type="info-circle" theme="twoTone" /> </Tooltip> </span>} className="media-volume">
                                            {getFieldDecorator('mediavolume', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        validator: (rule, value, callback) => {
                                                            let data = parseInt(value);
                                                            if (!data) {
                                                                callback(t('form.inputerrormsg', { field: "Media Volume" }));
                                                            } else if (data < 90 || data > 9999) {
                                                                callback(t('form.calcVolumeMinAndMax'));
                                                                return false;
                                                            }

                                                            callback();
                                                        }
                                                    }
                                                ],
                                            })(<InputNumber min={1} precision={0} type="number" suffix="ml." size="small" />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} className="pt-20">
                                        <div className="calc-volume">
                                            <Popover
                                                content={
                                                    <CalculateVolumeToolTip
                                                        form={this.props.form}
                                                        t={t}
                                                        calculateMediaVolume={this.calculateMediaVolume}
                                                        updateMediaVolumeVal={this.updateMediaVolumeVal}
                                                        visible={this.state.visible}
                                                        close={() => this.handleVisibleChange(false)}
                                                    />
                                                }
                                                trigger="click"
                                                visible={this.state.visible}
                                                onVisibleChange={this.handleVisibleChange}
                                                placement="right"
                                            >
                                                <Button icon="calculator" className="btn-calc-volume" size="small">&nbsp;<strong>{t('form.calcvolume')}</strong>&nbsp;</Button>
                                            </Popover>
                                        </div>
                                    </Col>
                                </Row>
                                <Form.Item label={<span> {t('form.concentration')} <Tooltip title={t('form.concentrationMinAndMax')}> <Icon type="info-circle" theme="twoTone" /> </Tooltip> </span>} className="concentration">
                                    {getFieldDecorator('concentration', {
                                        rules: [
                                            {
                                                required: true,
                                                initialValue: 1.0,
                                                validator: (rule, value, callback) => {
                                                    let data = Number(value);
                                                    if (!data) {
                                                        callback(t('form.inputerrormsg', { field: "Concentration" }));
                                                    } else if (data < 0.1 || data > 2.0) {
                                                        callback(t('form.concentrationMinAndMax'));
                                                        return false;
                                                    }
                                                    callback();
                                                }
                                            },
                                        ],
                                    })(
                                    //<InputNumber type="number" step={0.1} min={0.1} precision={1} suffix="X" size="small" />
                                    <Select placeholder="Please select a Concentration" size="small">
                                            <Option value="1.0">1.0</Option>
                                            <Option value="2.0">2.0</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label={<span> {t('form.dispenseflow')} <Tooltip title={t('form.dispinseflowMinAndMax')}> <Icon type="info-circle" theme="twoTone" /> </Tooltip> </span>} className="dispense-flow">
                                    {getFieldDecorator('dispinseflow', {
                                        rules: [
                                            {
                                                required: true,
                                                validator: (rule, value, callback) => {
                                                    let data = Number(value);
                                                    if (!data) {
                                                        callback(t('form.inputerrormsg', { field: "Dispense Flow" }));
                                                    } else if (data < 1.0 || data > 2.0) {
                                                        callback(t('form.dispinseflowMinAndMax'));
                                                        return false;
                                                    }

                                                    callback();
                                                }
                                            },
                                        ],
                                    })(<InputNumber type="number" step={0.1} min={1.0} precision={1} suffix="L/min" size="small" />)}
                                </Form.Item>
                                <Form.Item className="add-temp">
                                    {getFieldDecorator('addtemp', {
                                        valuePropName: 'checked',
                                    })(
                                        <Checkbox onChange={(e) => this.onAddTempChange(e)}>
                                            {t('form.addtemp')}
                                        </Checkbox>,
                                    )}
                                </Form.Item>
                                {this.state.addTempValue ? <Form.Item label={<span> {t('form.temp')} <Tooltip title={t('form.temperatureflowMinAndMax')}> <Icon type="info-circle" theme="twoTone" /> </Tooltip> </span>} className="temp" style={this.state.addTempValue === false ? { display: 'none' } : ''}>
                                    {getFieldDecorator('temperature', {
                                        rules: [
                                            {
                                                required: true,
                                                validator: (rule, value, callback) => {
                                                    let data = Math.round(Number(value));
                                                    if (!data) {
                                                        callback(t('form.inputerrormsg', { field: "Temperature" }));
                                                    } else if (data < 30 || data > 42) {
                                                        callback(t('form.temperatureflowMinAndMax'));
                                                        return false;
                                                    }
                                                    callback();
                                                }
                                            },
                                        ],
                                    })(<InputNumber step={1} precision={0} type="number" suffix="&#8451;" size="small" />)}
                                </Form.Item> : ''}
                               {this.state.addTempValue ? <Form.Item label={<span> {t('form.priority')} <Tooltip title={t('form.priorityTitle')}> <Icon type="info-circle" theme="twoTone" /> </Tooltip> </span>} className="priority">
                                    {getFieldDecorator('priority', {
                                        rules: [{ required: true, message: t('form.selecterrormsg', { field: "Priority" }) }],
                                        initialValue: "Temperature"
                                    })(
                                        <Select placeholder="Please select a Priority" size="small">
                                            <Option value="Flow">Flow</Option>
                                            <Option value="Temperature" selected>Temperature</Option>
                                        </Select>,
                                    )}
                                </Form.Item> : ''}
                            </Col>
                        </Row>
                    </Col>
                    <Col span={4}>
                        <Row >
                            <Col span={24}>
                                <QRCodeWithButton
                                    home={this.props.home}
                                    dispatch={this.props.dispatch}
                                    form={this.props.form}
                                    resetBtn={() => this.onAddTempChange({ target: { checked: false } })} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        )
    }
}
const TestDataFormWrapper = Form.create({
    name: 'testdataform',
    onValuesChange: (props, changedFields, allFields) => {
        if(props.home.qrCode) {
            props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'qrCode' })
            props.dispatch({ type: HOME.SET_PROP, value: true, prop: 'isSaveClick' });
            props.dispatch({ type: HOME.SET_PROP, value: false, prop: 'showID' });
        }
    }
})(withApollo(TestDataForm));

export default (TestDataFormWrapper);
